import React, { useMemo, useReducer } from 'react';
import { careTeamReducer } from './careTeamReducer';
import { CareTeamAction, CareTeamState } from './types';

export type CareTeamContext = {
  state: CareTeamState;
  dispatch: React.Dispatch<CareTeamAction>;
};

const initialState: CareTeamState = 'LOADING';

export const CareTeamContext = React.createContext<CareTeamContext | null>(
  null,
);

export const CareTeamProvider = (props: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(careTeamReducer, initialState);
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <CareTeamContext.Provider value={contextValue}>
      {props.children}
    </CareTeamContext.Provider>
  );
};
